import request from '@/plugins/http'

export function aGroupListApi(param) {
    return request.post('/api/agroup/storeList', param);
}
